import { CategoryEnum } from '@classifieds-sell/datalayer';

export const getPromotePageSubTitle = (c: CategoryEnum): string => {
    switch (c) {
        case CategoryEnum.residentialForRent:
            return `Reach NZ's largest property renting audience. Pay once and
            <b>relist for free</b> until rented¹.`;
        case CategoryEnum.residentialForSale:
        case CategoryEnum.newHomesHouseAndLand:
        case CategoryEnum.newHomesNewApartment:
        case CategoryEnum.newHomesNewHouse:
        case CategoryEnum.newHomesNewTownhouseAndTerraced:
            return `Reach NZ's largest property buying audience. Pay once and
            <b>relist for free</b> until sold¹.`;
        default:
            return '';
    }
};

export const getPromoteFooterNotes = (c: CategoryEnum): string => {
    const placeholder = '%categorisedText%';
    const originalText = `¹ If your property is not ${placeholder}, you may relist for free
    as a Bronze listing within 45 days of your listing ending.
    You can upgrade to Silver or Gold by paying the difference
    from a Bronze Listing. <br />² On average - Trade Me site
    statistics, January 2021 to June 2021.<br />
    ³ Prominent ad with 3x photos in a rotating carousel at top of relevant search results on Desktop devices.<br />
    Please note: On mobile, some promotional features may appear
    differently or not show.`;

    switch (c) {
        case CategoryEnum.residentialForRent:
            return originalText.replace(placeholder, 'rented');
        case CategoryEnum.residentialForSale:
            return originalText.replace(placeholder, 'sold');
        default:
            return '';
    }
};
